import { SignAssociation } from '../components/stock/sign-associations/edit-association/sign-association';
import { SignAssociationAsset } from '../components/stock/sign-associations/edit-association/sign-association-asset';
import { BoardTypeChoices } from '../model/product/board/board-part';
import IPBoard from '../model/product/ip-board/ip-board';
import { SignAsset } from '../model/sign/sign-asset';
import { CollectionHelper } from './collection-helper';
import ProductHelper from './product-helper';
import { StringHelper } from './string-helper';

export class IPBoardAssetHelper {
  private constructor() {}

  static getBoardPartSignExamples(ipBoard: IPBoard): SignAssociationAsset[] {
    if (ipBoard == null || ipBoard.boardPart == null) {
      return null;
    }
    const toReturn = [
      this.getBoardPartSignExampleLeft(ipBoard),
      this.getBoardPartSignExampleRight(ipBoard),
    ];
    CollectionHelper.filterInPlace(
      toReturn,
      (e) => e != null && e.asset != null
    );
    return toReturn;
  }

  private static getBoardPartSignExampleLeft(
    ipBoard: IPBoard
  ): SignAssociationAsset {
    if (this.mustShowEmptyLeftExample(ipBoard)) {
      return null;
    }

    const exampleCandidate = this.isExampleCandidate(ipBoard.boardPart.sticker)
      ? ipBoard.boardPart.sticker
      : this.isExampleCandidate(ipBoard.boardPart.titleAdjustment)
      ? ipBoard.boardPart.titleAdjustment
      : this.isExampleCandidate(ipBoard.boardPart.phoneNumberAdjustment)
      ? ipBoard.boardPart.phoneNumberAdjustment
      : null;
    if (exampleCandidate != null) {
      return this.getSignAssociationDisplayExample(exampleCandidate);
    } else if (ipBoard.boardPart.sign != null) {
      return this.getSignDisplayExample(ipBoard.boardPart.sign.examples);
    }
  }

  private static mustShowEmptyLeftExample(ipBoard: IPBoard): boolean {
    return (
      ipBoard.boardPart.sign == null ||
      (ipBoard.boardPart.sign != null && this.leftNonStockAdjustment(ipBoard))
    );
  }

  private static leftNonStockAdjustment(ipBoard: IPBoard): boolean {
    return (
      !StringHelper.isEmpty(ipBoard.boardPart.otherTitle) ||
      !StringHelper.isEmpty(ipBoard.boardPart.otherPhoneNumber) ||
      !StringHelper.isEmpty(ipBoard.boardPart.otherSticker)
    );
  }

  private static getBoardPartSignExampleRight(
    ipBoard: IPBoard
  ): SignAssociationAsset {
    if (this.mustShowEmptyRightExample(ipBoard)) {
      return null;
    }
    const exampleCandidate = this.isExampleCandidate(
      ipBoard.boardPart.otherTitleAdjustment
    )
      ? ipBoard.boardPart.otherTitleAdjustment
      : this.isExampleCandidate(ipBoard.boardPart.otherPhoneNumberAdjustment)
      ? ipBoard.boardPart.otherPhoneNumberAdjustment
      : this.isExampleCandidate(ipBoard.boardPart.sticker)
      ? ipBoard.boardPart.sticker
      : null;
    if (exampleCandidate != null) {
      return this.getSignAssociationDisplayExample(exampleCandidate);
    } else if (ipBoard.boardPart.sign != null) {
      return this.getSignDisplayExample(ipBoard.boardPart.sign.examples);
    }
  }

  private static mustShowEmptyRightExample(ipBoard: IPBoard): boolean {
    return (
      !this.rightSideCanDiffer(ipBoard) ||
      ipBoard.boardPart.sign == null ||
      (ipBoard.boardPart.sign != null && this.rightNonStockAdjustment(ipBoard))
    );
  }

  private static rightNonStockAdjustment(ipBoard: IPBoard): boolean {
    return (
      !StringHelper.isEmpty(ipBoard.boardPart.otherSideOtherTitle) ||
      !StringHelper.isEmpty(ipBoard.boardPart.otherSideOtherPhoneNumber) ||
      !StringHelper.isEmpty(ipBoard.boardPart.otherSticker)
    );
  }

  private static isExampleCandidate(signAssociation: SignAssociation): boolean {
    return signAssociation != null && signAssociation.graphicsComplete;
  }

  private static rightSideCanDiffer(ipBoard: IPBoard): boolean {
    return (
      ipBoard.boardPart.boardType != null &&
      ipBoard.boardPart.boardType.ordinal === BoardTypeChoices.V.ordinal &&
      ipBoard.boardPart.sign != null &&
      (ProductHelper.doTitleSidesDiffer(ipBoard.boardPart) ||
        ProductHelper.doPhoneNumberSidesDiffer(ipBoard.boardPart))
    );
  }

  private static getSignDisplayExample(examples: SignAsset[]): SignAsset {
    return CollectionHelper.isPopulated(examples)
      ? examples.find((e) => e != null && !e.archived)
      : null;
  }

  private static getSignAssociationDisplayExample(
    signAssociation: SignAssociation
  ): SignAssociationAsset {
    return CollectionHelper.isPopulated(signAssociation.examples)
      ? signAssociation.examples.find((e) => e != null && !e.archived)
      : null;
  }
}
